import { useParams, Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Btn } from "@/components/Btn";
import { PROJECTS, ASSETS } from "@/lib/data";

export default function ProjectDetail() {
  const { slug } = useParams();
  const p = PROJECTS.find((x) => x.slug === slug);
  if (!p) return (
    <section className="flex min-h-screen items-center bg-ink text-white"><div className="mx-auto max-w-[1440px] px-6 md:px-12"><h1 className="font-serif text-5xl">Project not found.</h1><div className="mt-8"><Btn to="/work" variant="gold">Back to work</Btn></div></div></section>
  );
  return (
    <>
      <section className="relative bg-ink text-white">
        <div className="mx-auto max-w-[1440px] px-6 pt-40 pb-14 md:px-12 md:pt-52">
          <p className="text-[11px] uppercase tracking-label text-champagne">{p.type} · {p.industry}</p>
          <h1 className="mt-6 font-serif text-5xl tracking-tight md:text-7xl">{p.title}</h1>
          <p className="mt-4 text-[11px] uppercase tracking-label text-white/60">{p.tags.join(" · ")}</p>
        </div>
        <div className="mx-auto max-w-[1440px] px-6 md:px-12"><img src={p.image} alt={p.title} className="aspect-[16/8] w-full object-cover" /></div>
      </section>
      <section className="bg-paper text-ink">
        <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
          <div className="grid gap-12 md:grid-cols-3">
            {[["The challenge", p.challenge], ["Our approach", p.approach], ["The result", p.result]].map(([t, c], i) => (
              <Reveal key={t} delay={i * 0.06}><div><p className="text-[11px] uppercase tracking-label text-ink/40">{t}</p><p className="mt-4 text-lg leading-relaxed text-ink/75">{c}</p></div></Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <div className="mt-20 grid items-end gap-6 md:grid-cols-3">
              <img src={ASSETS.laptop} alt="Website concept — desktop" loading="lazy" className="md:col-span-2 w-full object-cover" />
              <img src={ASSETS.phone} alt="Website concept — mobile" loading="lazy" className="w-full object-cover" />
            </div>
            <p className="mt-4 text-[10px] uppercase tracking-label text-ink/40">Concept — Wave Eleven design study</p>
          </Reveal>
          <div className="mt-20 flex flex-col items-start justify-between gap-6 border-t border-ink/12 pt-10 md:flex-row md:items-center">
            <Link to="/work" className="text-[11px] uppercase tracking-label text-ink transition-opacity hover:opacity-60">← All projects</Link>
            <Btn to="/start" variant="primary" testid="project-cta">Start your project</Btn>
          </div>
        </div>
      </section>
    </>
  );
}
